import { Navigate } from 'react-router-dom';

import { NBA_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { Wheel } from '@sorare/marketplace/src/components/Wheel';

export const NBAMarketWheel = () => {
  const {
    flags: {
      marketDailyWheel = { baseball: false, football: false, nba: false },
    },
  } = useFeatureFlags();

  if (!marketDailyWheel.nba) {
    return <Navigate to={NBA_MARKET} replace />;
  }

  return <Wheel />;
};

export default NBAMarketWheel;
